// client/src/components/CashierPubViewer.js

import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const CashierPubViewer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Récupération des paramètres passés dans l'URL
  const urlParams = new URLSearchParams(location.search);
  const imageUrl = urlParams.get('url');
  const logoUrl = urlParams.get('logo');
  const pseudo = urlParams.get('pseudo');

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="eb-screen" style={{ alignItems: 'flex-start' }}>
      <div style={{ width: '100%', maxWidth: 560, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 20 }}>
        {/* Bouton Retour */}
        <div>
          <button onClick={handleBack} className="eb-btn eb-btn--secondary">
            <FaArrowLeft aria-hidden="true" /> Retour
          </button>
        </div>

        {/* Affichage du logo et du pseudo */}
        {(logoUrl || pseudo) && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, minWidth: 0 }}>
            {logoUrl && (
              <img
                src={logoUrl}
                alt="Logo"
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: '50%',
                  objectFit: 'cover',
                  border: '1px solid var(--eb-border)',
                  boxShadow: 'var(--eb-shadow-sm)',
                  flexShrink: 0,
                }}
              />
            )}
            {pseudo && (
              <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, textAlign: 'left', overflowWrap: 'anywhere' }}>{pseudo}</h2>
            )}
          </div>
        )}

        {/* Conteneur de l'image */}
        {imageUrl ? (
          <div
            className="eb-card"
            style={{ overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 0 }}
          >
            <img
              src={imageUrl}
              alt="Promotion"
              style={{ width: '100%', height: 'auto', display: 'block', objectFit: 'cover' }}
            />
          </div>
        ) : (
          <div className="eb-card eb-card--pad" style={{ textAlign: 'center', color: 'var(--eb-muted)' }}>
            Aucune image à afficher
          </div>
        )}
      </div>
    </div>
  );
};

export default CashierPubViewer;
